import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { BookOpenIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferBlock() {
  return <section id="offer" className="py-10 sm:py-14 relative" data-id="element-164">
      <div className="absolute inset-0 bg-gradient-radial from-gold/10 to-transparent opacity-50 blur-3xl -z-10" data-id="element-165" />

      <div className="mx-auto max-w-5xl px-6 lg:px-8" data-id="element-166">
        <div className="bg-navy-light border border-gold/20 rounded-3xl p-8 sm:p-12 shadow-[0_0_50px_rgba(212,168,83,0.1)] relative overflow-hidden" data-id="element-167">
          {/* Decorative glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-md h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-168" />

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-169">
            <FadeIn direction="right" data-id="element-170">
              <img src="https://cdn.magicpatterns.com/uploads/3wNJ8cPmdAYXx6vMg6UdiJ/Mockup.png" alt="Kit Gato Zen" className="w-full max-w-sm mx-auto rounded-xl shadow-2xl ring-1 ring-white/10" data-id="element-171" />
            </FadeIn>

            <FadeIn direction="left" className="text-center lg:text-left" data-id="element-172">
              <div className="inline-flex items-center gap-2 rounded-full bg-gold/10 px-4 py-2 text-sm font-medium text-gold ring-1 ring-inset ring-gold/20 mb-6" data-id="element-173">
                <BookOpenIcon className="h-4 w-4" data-id="element-174" />
                <span data-id="element-175">Acceso Inmediato</span>
              </div>

              <h2 className="text-3xl sm:text-4xl font-bold mb-6" data-id="element-176">
                Recuperá tu descanso hoy mismo
              </h2>

              <p className="text-lg text-slate-400 font-sans mb-8" data-id="element-177">
                Por una fracción de lo que cuesta una consulta con un
                conductista felino.
              </p>

              <div className="mb-8" data-id="element-178">
                <p className="text-sm text-slate-500 font-sans uppercase tracking-wider mb-2" data-id="element-179">
                  Precio Único
                </p>
                <div className="flex items-baseline justify-center lg:justify-start gap-2" data-id="element-180">
                  <span className="text-5xl font-bold text-gold-light" data-id="element-181">
                    $9.499
                  </span>
                  <span className="text-xl text-slate-400 font-sans" data-id="element-182">ARS</span>
                </div>
              </div>

              <Button href="https://amigospeludosarg.shop/cart/49098154606834:1" fullWidth className="mb-4 text-xl py-5" onClick={() => trackAddToCart()} data-id="element-183">
                ¡QUIERO VOLVER A DORMIR!
              </Button>

              <p className="text-sm text-slate-400 font-sans text-center" data-id="element-184">
                Comprá ahora y recibí el protocolo en tu email al instante.
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}